import { types } from 'mobx-state-tree';

const ParkingPass = types.model('ParkingPass', {
    id: types.identifierNumber,
    assign_token: types.maybeNull(types.string),
    type: types.maybeNull(types.string),
    creation_type: types.maybeNull(types.string),
    parking_field_id: types.maybeNull(types.number),
    season_id: types.maybeNull(types.number),
    game_id: types.maybeNull(types.number),
    user_id: types.maybeNull(types.number),
    assigned_at: types.maybeNull(types.string),
    first_name: types.maybeNull(types.string),
    last_name: types.maybeNull(types.string),
    email: types.maybeNull(types.string),
    phone: types.maybeNull(types.string),
    // Joined relations — kept frozen so backend-added columns don't break the snapshot.
    parking_field: types.maybeNull(types.frozen()),
    user: types.maybeNull(types.frozen()),
});

export default ParkingPass;
